import React, { useState } from 'react';
import styles from './CompanyName.module.css';
import { FormTitle } from '../../../Common/FormTitle';
import { NextButton } from '../../../Common/CtaButton/NextButton';
import { FormField } from '../../../Common/FormField';
import { LeadText } from '../../../Common/LeadText';
import {
    HandleCompanyNameChangeFunction,
    ValidateCompanyNameFunction,
} from './types';

export const CompanyName = () => {
    const [companyName, setCompanyName] = useState('');
    const [companyNameError, setCompanyNameError] = useState('');
    const [isFormValid, setIsFormValid] = useState(false);

    const validateCompanyName: ValidateCompanyNameFunction = (
        value,
        shouldShowError = false
    ) => {
        if (!value) {
            setIsFormValid(false);
            setCompanyNameError(
                shouldShowError ? '会社名・店舗名を入力してください。' : ''
            );
            return;
        }
        setCompanyNameError('');
        setIsFormValid(true);
    };

    const handleCompanyNameChange: HandleCompanyNameChangeFunction = value => {
        setCompanyName(value);
        validateCompanyName(value, false);
    };

    const handleCompanyBlur = () => {
        validateCompanyName(companyName, true);
    };
    return (
        <div className={styles.wrapper}>
            <div className={styles.selectionWrapper}>
                <div className={styles.monthbox}>
                    <FormTitle
                        formTitleText="直近の会社名・店舗名は？"
                        dataViewLabel="EF_直近会社名_pv"
                        dataClickLabel="EF_直近会社名_戻る"
                    />
                </div>
                <div className={styles.companyField}>
                    <FormField
                        label=""
                        placeholder="会社名・店舗名"
                        value={companyName}
                        onChange={handleCompanyNameChange}
                        onBlur={handleCompanyBlur}
                    />
                    <div className={styles.errorMessagesWrapper}>
                        {companyNameError && (
                            <p className={styles.errorMessages}>
                                {companyNameError}
                            </p>
                        )}
                    </div>
                    <LeadText text="登録が完了後に、直近1社目以前の情報も入力することができます" />
                </div>
                <NextButton
                    formKey={['userResumesAttributes', 'companyName']}
                    formValue={[0, companyName]}
                    displayFormKey={'companyName'}
                    displayFormValue={companyName}
                    isDisabled={!isFormValid}
                    dataClickLabel="EF_直近会社名_次へ"
                />
            </div>
        </div>
    );
};
